webpackJsonp([55702396619907],{

/***/ 351:
/***/ (function(module, exports) {

	module.exports = {"data":{"site":{"siteMetadata":{"title":"Gatsby + Netlify CMS Starter"}},"allMarkdownRemark":{"group":[{"fieldValue":"intro","totalCount":1}]}},"pathContext":{}}

/***/ })

});


// WEBPACK FOOTER //
// path---tags-81935bf01fc905bce58b.js